// extracted by extract-css-chunks-webpack-plugin
module.exports = {"surchargeModal":"surcharge-modal__surchargeModal__2eqPa","surchargeModalBody":"surcharge-modal__surchargeModalBody__35UiY"};